import * as React from "react"
import styled from "styled-components"
import { colors, scale, fontWeight } from "../../styles"
import { Icon } from "../Icon"

export interface NavButtonProps extends React.HTMLProps<HTMLButtonElement> {
	active?: boolean
}

const ButtonIcon = styled.span`
	position: absolute;
	top: 50%;
	transform: translate(0, -50%);
	width: ${scale.px(3)};
	height: ${scale.px(3)};
`

const NavButtonStyled = styled.button<NavButtonProps>`
	display: flex;
	align-items: center;
	height: ${scale.px(6)};
	position: relative;
	width: 100%;
	padding: 0 ${scale.px(6)} 0 ${scale.px(2)};
	font-size: ${scale.px(2)};
	font-weight: ${fontWeight.bold};
	color: ${colors.navy};
	background-color: ${colors.white};
	border: solid ${colors.blue33};
	border-width: 1px 0;

	${ButtonIcon} {
		transition: all 0.2s ease-in;
		opacity: 0;
		right: ${scale.px(3)};
	}

	&[aria-expanded="true"],
	&:hover {
		background-color: ${colors.blue11};

		${ButtonIcon} {
			opacity: 1;
			right: ${scale.px(1.5)};
		}
	}

	&:hover ${ButtonIcon} {
		svg > * {
			fill: ${colors.hoverBlue};
		}
	}

	li:not(:first-child) > & {
		border-top: none;
	}
`

const NavButton: React.FC<NavButtonProps> = ({
	children,
	ref,
	type,
	as,
	...rest
}) => {
	return (
		<NavButtonStyled {...rest}>
			{children}
			<ButtonIcon>
				<Icon icon="arrow-right" />
			</ButtonIcon>
		</NavButtonStyled>
	)
}

export { NavButton }
